module.exports = __webpack_public_path__ + "img/interactive-agency.2deba364.png";